/**
 * Gera um valor de ordenação para uma coluna de data
 * @param {string|Date|null|undefined} date - Data a ser convertida
 * @returns {number} Timestamp ou 0 se inválido
 */
export function getDateSortValue(date) {
  if (!date) {
    return 0;
  }
  
  try {
    const timestamp = new Date(date).getTime();
    return isNaN(timestamp) ? 0 : timestamp;
  } catch (error) {
    return 0;
  }
}

/**
 * Gera um valor de ordenação para lead time (valores null vão para o final)
 * @param {object|null|undefined} leadTime - Objeto leadTime com hoursDecimal
 * @returns {number} Valor decimal ou Number.MAX_SAFE_INTEGER se null
 */
export function getLeadTimeSortValue(leadTime) {
  if (!leadTime || leadTime.hoursDecimal === null || leadTime.hoursDecimal === undefined) {
    return Number.MAX_SAFE_INTEGER;
  }
  return leadTime.hoursDecimal;
}

/**
 * Gera um valor de ordenação para string (valores null/undefined viram string vazia)
 * @param {string|null|undefined} value - Valor a ser ordenado
 * @returns {string} Valor ou string vazia
 */
export function getStringSortValue(value) {
  return value || '';
}

